export default __webpack_public_path__ + "static/media/icon.691e44ed.svg";